import API from "../../../../app/api";
import { handleApiError } from "../../../../app/errorHandler";

export const getProductDetail = async (slug, sku) => {
  if (!slug) {
    throw new Error("Product slug is required");
  }

  try {
    const { data } = await API.get(`/product-details/p/${slug}/${sku}`, {
      params: { sku },
    });

    if (!data?.success) {
      throw new Error(data?.message || "Failed to fetch product details");
    }

    return data.data;
  } catch (error) {
    throw handleApiError(error, "Unable to fetch product details");
  }
};

/**
 * 
 * @param {*} pincode 
 * @returns 
 */
export const checkPincodeService = async (pincode) => {
  try {
    if (!pincode) {
      throw new Error("Delivery Pincode is required");
    }
    const res = await API.post('/services/pincode', { pincode });
    if (!res.data?.success) {
      throw new Error(res.data?.message || "Failed to fetch Pincode Service Error Details");
    }
    return res;
  } catch (error) {
    console.error("Pincode Service error:", error);
    throw error;
  }
};
